/**************************************************
 * Nombre:       Home_Lanza
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import uno from '../../../Recursos/lanza_uno.png'
import dos from '../../../Recursos/lanza_dos.png'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Home_Lanza = () => {
    const {sCell, masSM, sTab} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: 'linear-gradient(180deg, #5356FF 0%, #91DDCF 105.47%)'
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 8}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 3, sm: 2, md: 2}} sx={{justifyContent: 'flex-start'}}>
                            <img src={uno} width={'auto'} height={sCell ? 200 : sTab ? 250 : 400}/>
                        </Grid>

                        <Grid container size={{xs: 4, sm: 3, md: 3}} sx={{justifyContent: 'flex-start'}}>
                            <img src={dos} width={'auto'} height={sCell ? 200 : sTab ? 250 : 400}/>
                        </Grid>

                        <Grid container size={{xs: 5, sm: 7, md: 7}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{color: '#fff'}}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography
                                        sx={{fontSize: sCell ? 12 : 24, fontWeight: 700}}>Dropshipping</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 1}}>
                                    <Typography sx={{fontSize: !masSM ? 24 : 64, fontWeight: 800, lineHeight: 1.1}}>Lanza
                                        tu negocio
                                        con productos
                                        reconocidos</Typography>
                                </Grid>

                                {!sCell &&
                                    <>
                                        <Grid container size={{xs: 12, sm: 12, md: 8}}
                                              sx={{justifyContent: 'flex-start', mt: 2}}>
                                            <Typography sx={{fontSize: 20, fontWeight: 400}}>
                                                Vende una amplia gama de productos sin inventario, sin local.
                                                Nosotros enviamos, tú solo ganas la comisión.
                                            </Typography>
                                        </Grid>


                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start', mt: 4}}>
                                            <Button sx={{
                                                borderRadius: 14,
                                                px: 6,
                                                pt: 1,
                                                pb: 0.8,
                                                fontSize: sCell ? 14 : 16
                                            }}>Más Información</Button>
                                        </Grid>

                                    </>

                                }

                            </Grid>
                        </Grid>

                        {sCell &&

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'center', mt: 4}}>
                                <Button sx={{
                                    borderRadius: 14,
                                    px: 6,
                                    pt: 1,
                                    pb: 0.8,
                                    fontSize: sCell ? 14 : 16
                                }}>Más Información</Button>
                            </Grid>

                        }

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Lanza